export default __webpack_public_path__ + "static/media/pro-elevate-lav-1.606fb9a5.png";